import { render, staticRenderFns } from "./LastCallRestaurants.vue?vue&type=template&id=6d9eae6f&"
import script from "./LastCallRestaurants.vue?vue&type=script&lang=js&"
export * from "./LastCallRestaurants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports